var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSkLogo1 = function SvgSkLogo1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 208.56,
    height: 65.653336,
    viewBox: "0 0 208.56 65.653336",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,65.653333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 668.047,225.516 c 8.648,0 15.133,0.996 19.457,2.992 7.648,3.492 11.473,10.39 11.473,20.703 0,11.141 -3.7,18.625 -11.098,22.449 -4.16,2.16 -10.395,3.242 -18.707,3.242 H 624.52 v -49.386 h 43.527 z m -3.867,-30.43 h -39.66 v -72.09 h -37.54 v 183.832 h 90.172 c 12.887,-0.246 22.801,-1.828 29.743,-4.738 6.945,-2.91 12.828,-7.192 17.648,-12.848 3.992,-4.656 7.152,-9.808 9.48,-15.465 2.325,-5.652 3.493,-12.093 3.493,-19.328 0,-8.73 -2.207,-17.316 -6.614,-25.754 -4.406,-8.441 -11.679,-14.406 -21.824,-17.898 8.481,-3.41 14.488,-8.25 18.024,-14.527 3.531,-6.282 5.3,-15.864 5.3,-28.747 v -12.347 c 0,-8.399 0.332,-14.094 0.996,-17.086 0.997,-4.738 3.325,-8.235 6.985,-10.477 v -4.617 h -42.278 c -1.167,4.074 -1.996,7.359 -2.496,9.856 -0.996,5.152 -1.539,10.433 -1.621,15.836 l -0.25,17.085 c -0.168,11.727 -2.308,19.54 -6.422,23.45 -4.117,3.906 -11.828,5.863 -23.136,5.863",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 839.031,204.563 c -0.582,9.394 -3.429,16.527 -8.543,21.386 -5.113,4.867 -11.453,7.297 -19.019,7.297 -8.231,0 -14.614,-2.578 -19.145,-7.73 -4.531,-5.157 -7.379,-12.141 -8.543,-20.953 z m 35.168,-41.657 c -0.914,-8.066 -5.109,-16.258 -12.594,-24.57 -11.64,-13.219 -27.937,-19.828 -48.89,-19.828 -17.293,0 -32.551,5.57 -45.77,16.711 -13.218,11.14 -19.832,29.265 -19.832,54.379 0,23.527 5.965,41.57 17.899,54.125 11.929,12.554 27.418,18.832 46.457,18.832 11.304,0 21.492,-2.121 30.554,-6.36 9.063,-4.242 16.547,-10.933 22.45,-20.078 5.32,-8.066 8.769,-17.422 10.351,-28.062 0.914,-6.235 1.289,-15.215 1.121,-26.938 H 782.91 c 0.496,-13.64 4.778,-23.199 12.844,-28.687 4.906,-3.41 10.809,-5.114 17.711,-5.114 7.312,0 13.262,2.079 17.836,6.239 2.492,2.242 4.695,5.363 6.609,9.351 h 36.289",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 941.613,262.805 c 16.965,0 30.809,-3.367 41.532,-10.102 10.64,-6.816 16.753,-18.543 18.335,-35.172 h -35.546 c -0.496,4.574 -1.789,8.192 -3.868,10.852 -3.906,4.82 -10.558,7.234 -19.953,7.234 -7.73,0 -13.242,-1.207 -16.523,-3.617 -3.285,-2.414 -4.926,-5.238 -4.926,-8.48 0,-4.075 1.742,-7.028 5.238,-8.856 3.493,-1.914 15.836,-5.195 37.039,-9.851 14.133,-3.329 24.735,-8.356 31.801,-15.09 6.988,-6.821 10.478,-15.34 10.478,-25.571 0,-13.468 -5.01,-24.464 -15.029,-32.984 -10.019,-8.523 -25.503,-12.785 -46.457,-12.785 -21.367,0 -37.144,4.512 -47.328,13.531 -10.187,9.02 -15.277,20.516 -15.277,34.484 h 36.043 c 0.746,-6.32 2.367,-10.808 4.863,-13.468 4.406,-4.739 12.555,-7.11 24.445,-7.11 6.985,0 12.532,1.039 16.649,3.118 4.113,2.078 6.172,5.199 6.172,9.355 0,3.992 -1.664,7.023 -4.988,9.102 -3.325,2.078 -15.672,5.656 -37.04,10.726 -15.382,3.824 -26.234,8.606 -32.55,14.344 -6.321,5.652 -9.481,13.801 -9.481,24.445 0,12.555 4.93,23.34 14.781,32.363 9.852,9.02 23.715,13.532 41.59,13.532 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.14,258.938 V 122.996 h -36.05 v 135.942 z m 0,49.015 v -32.801 h -36.05 v 32.801 h 36.05",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1107.32,190.094 c 0,-12.555 2.5,-22.571 7.49,-30.055 4.9,-7.566 12.39,-11.351 22.45,-11.351 10.06,0 17.71,3.742 22.95,11.226 5.23,7.481 7.85,17.168 7.85,29.059 0,16.629 -4.2,28.515 -12.59,35.668 -5.16,4.324 -11.15,6.488 -17.96,6.488 -10.4,0 -18.03,-3.93 -22.89,-11.789 -4.86,-7.856 -7.3,-17.606 -7.3,-29.246 z m 95.79,116.488 V 122.996 h -34.55 v 18.832 c -5.07,-8.062 -10.85,-13.926 -17.33,-17.586 -6.49,-3.656 -14.56,-5.484 -24.2,-5.484 -15.88,0 -29.25,6.422 -40.1,19.269 -10.85,12.844 -16.27,29.328 -16.27,49.45 0,23.199 5.34,41.445 16.02,54.75 10.69,13.3 24.97,19.953 42.84,19.953 8.24,0 15.55,-1.809 21.95,-5.422 6.41,-3.617 11.6,-8.629 15.59,-15.031 v 64.855 h 36.05",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1307.7,204.563 c -0.58,9.394 -3.43,16.527 -8.54,21.386 -5.12,4.867 -11.46,7.297 -19.02,7.297 -8.24,0 -14.62,-2.578 -19.15,-7.73 -4.53,-5.157 -7.38,-12.141 -8.54,-20.953 z m 35.17,-41.657 c -0.92,-8.066 -5.11,-16.258 -12.6,-24.57 -11.64,-13.219 -27.93,-19.828 -48.89,-19.828 -17.29,0 -32.55,5.57 -45.77,16.711 -13.22,11.14 -19.83,29.265 -19.83,54.379 0,23.527 5.97,41.57 17.9,54.125 11.93,12.554 27.42,18.832 46.46,18.832 11.3,0 21.49,-2.121 30.55,-6.36 9.06,-4.242 16.55,-10.933 22.45,-20.078 5.32,-8.066 8.77,-17.422 10.35,-28.062 0.92,-6.235 1.29,-15.215 1.12,-26.938 h -93.03 c 0.49,-13.64 4.78,-23.199 12.84,-28.687 4.91,-3.41 10.81,-5.114 17.71,-5.114 7.32,0 13.26,2.079 17.84,6.239 2.49,2.242 4.69,5.363 6.61,9.351 h 36.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1442.24,222.148 c -3.49,6.985 -10.15,10.477 -19.96,10.477 -12.05,0 -20.33,-5.113 -24.82,-15.344 -2.32,-5.402 -3.49,-12.304 -3.49,-20.699 v -73.586 h -35.42 v 135.692 h 34.3 v -19.829 c 4.57,6.985 8.9,12.012 12.97,15.09 7.32,5.489 16.59,8.231 27.81,8.231 14.05,0 25.55,-3.676 34.49,-11.035 8.93,-7.36 13.4,-19.563 13.4,-36.606 v -91.543 h -36.41 v 82.688 c 0,7.152 -0.96,12.636 -2.87,16.464 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1564.23,148.316 V 121.75 l -16.83,-0.621 c -16.8,-0.582 -28.27,2.324 -34.42,8.726 -4,4.075 -5.99,10.356 -5.99,18.833 v 83.687 h -18.96 v 25.316 h 18.96 v 37.914 h 35.17 v -37.914 h 22.07 v -25.316 h -22.07 v -71.84 c 0,-5.57 0.7,-9.039 2.12,-10.41 1.41,-1.375 5.74,-2.059 12.97,-2.059 1.08,0 2.22,0.02 3.43,0.063 1.2,0.039 2.39,0.101 3.55,0.187",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 492.398,492.398 h -369.3 C 55.1133,492.398 0,437.285 0,369.301 V 123.098 C 0,55.1133 55.1133,0 123.098,0 h 246.203 c 67.984,0 123.097,55.1133 123.097,123.098 v 369.3 z M 476.242,476.242 V 123.098 C 476.242,64.1328 428.27,16.1563 369.301,16.1563 H 123.098 c -58.9652,0 -106.9417,47.9765 -106.9417,106.9417 v 246.203 c 0,58.969 47.9765,106.941 106.9417,106.941 h 353.144",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 245.891,252.273 c -32.715,26.899 -103.653,10.024 -111.313,43.504 -4.027,17.614 13.547,33.192 36.274,33.192 20.468,0 40.988,-4.59 48.796,-33.129 h 26.243 z m 160.988,55.559 h -59.117 l -56.242,-61.59 v 123.059 h -45.629 v -29.817 c -1.489,1.926 -3.059,3.832 -4.821,5.696 -16.59,17.566 -40.496,26.472 -71.062,26.472 -35.348,0 -55.445,-15.82 -66.086,-29.089 -13.2072,-16.473 -19.1017,-38.954 -15.0197,-57.274 10.5704,-47.43 54.5777,-55.004 86.9067,-59.207 25.523,-3.32 49.941,-7.953 49.293,-30.703 -0.676,-23.609 -27.289,-29.414 -44.754,-29.414 -45.496,0 -47.035,33.625 -47.035,33.625 H 84.3828 c 0.7149,-12.621 4.5352,-32.899 20.0782,-50.297 17.023,-19.059 42.555,-28.723 75.887,-28.723 25.566,0 48.851,8.332 65.543,23.121 v -20.328 h 45.629 v 58.09 l 16.148,17.66 46.094,-75.75 h 53.105 l -67.07,110.946 67.082,73.523",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkLogo1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sk-logo-1.4af16352.svg";
export { ForwardRef as ReactComponent };